import {lazy} from "react";
const Activation = lazy(()=> import('@src/views/activation'));
const ActivationMission = lazy(()=> import('@src/views/activation/mission'));
const Register = lazy(()=> import('@src/views/register'));
const Redirect = lazy(()=> import('@src/views/redirect'));
// import Activation from '@src/views/activation';
// import Register from '@src/views/register';

export const publicRoutes = [
  {
    path: '/login',
    element: <Register isOpen={true}/>,
  },
  {
    path: '/redirect',
    element: <Redirect />,
  },
  {
    path: '/activation/:missionId',
    element: <ActivationMission />,
  },
  {
    path: '/activation',
    element: <Activation />,
  },
  {
    path: '/*',
    element: <Activation />,
  }
];